import { Box, SxProps, Theme } from '@mui/material';

import { FC } from 'react';
import Link from 'next/link';
import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

interface storeBadgeProps {
  logo: string;
  path: string;
  /**
   * Accessible name for the link. The badge artwork is an image, so without it
   * the anchor has no name at all. Store names are proper nouns, so they are
   * not run through react-intl.
   */
  name: string;
}

export const StoreBadge: FC<storeBadgeProps> = ({ logo, path, name }) => {
  const sxStoreBadge: Partial<SxProps<Theme>> = {
    display: 'flex',
    transitionDuration: '300ms',
    ':hover': {
      opacity: 0.8,
    },
  };

  return (
    <Link href={path} legacyBehavior passHref>
      <Box
        sx={sxStoreBadge}
        component='a'
        target={'_blank'}
        rel='noopener'
        aria-label={name}
      >
        {/*
          Decorative: the anchor carries the accessible name, so an alt here
          would only make screen readers announce the same link twice.
        */}
        <ImageBoxFuture
          img={logo}
          title=''
          objectFit='contain'
          sx={{
            width: pxToRem(165),
            height: pxToRem(48),
          }}
        />
      </Box>
    </Link>
  );
};

export default StoreBadge;
